import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../axiosInstance';
import {
  errorResponseParser,
  successResponseParser,
} from '../../utils/handlers';
import { NotificationUrl } from '../../utils/Constant';

export const sendnotifydetails = createAsyncThunk(
  'sendnotifydetails',
  async (newSub, { rejectWithValue, dispatch }) => {
    try {
      const empId = JSON.parse(localStorage.getItem('userData'))?.employeeId;

      const res = await axios.post(`${NotificationUrl}/pushSubscription`, {
        subscription: newSub,
        empId: empId,
        appId: 'expense',
      });

      return successResponseParser(res);
    } catch (error) {
      return rejectWithValue(errorResponseParser(error, dispatch));
    }
  }
);

export const pushnotify = createSlice({
  name: 'pushnotify',
  initialState: {
    isLoading: false,
    data: null,
    apiError: '',
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(sendnotifydetails.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(sendnotifydetails.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    });
    builder.addCase(sendnotifydetails.rejected, (state) => {
      state.apiError = 'Something went wrong';
      state.isLoading = false;
      state.data = null;
    });
  },
});

export default pushnotify.reducer;
